export default {
"doc_title": "دليل لوحة التحكم",
  "doc_subtitle": "كل ما تحتاجه لإدارة عملك مثل منصة تجارة إلكترونية حديثة.",

  "profile_setup": "إعداد الملف الشخصي",
  "profile_1": "المعلومات الأساسية (الاسم، البريد الإلكتروني، الاتصال)",
  "profile_2": "تفاصيل المورد / المطعم",
  "profile_3": "العنوان والموقع",
  "profile_4": "تفاصيل البنك والدفع",
  "profile_5": "تحميل المستندات المطلوبة",

  "dashboard_overview": "نظرة عامة على لوحة التحكم",
  "dash_1": "الإيرادات – الأرباح الشهرية",
  "dash_2": "الطلبات المعلقة – طلبات تنتظر الإجراء",
  "dash_3": "مخزون منخفض – منتجات تحتاج إعادة تعبئة",
  "dash_4": "معدل التنفيذ – نجاح الطلبات",
  "dash_5": "اتجاهات المبيعات – تحليلات بيانية",
  "dash_6": "حالة المخزون",

  "products": "إدارة المنتجات",
  "prod_1": "إضافة المنتجات مع الصور والأسعار",
  "prod_2": "تعديل أو تعطيل المنتجات في أي وقت",
  "prod_3": "التحكم في توفر المخزون",
  "prod_4": "تحديد الفئات لزيادة الظهور",

  "orders_delivery": "الطلبات والتوصيل",
  "order_1": "قبول أو رفض الطلبات",
  "order_2": "عرض تفاصيل الطلب كاملة",
  "order_3": "تتبع حالة التوصيل",
  "order_4": "تحديث حالة الطلب",

  "offers": "العروض والترويج",
  "offer_1": "إنشاء خصومات لجذب العملاء",
  "offer_2": "استخدام أكواد الخصم للحملات",
  "offer_3": "تشغيل عروض مجمعة لزيادة قيمة الطلب",

  "inventories": "المخزون",
  "inv_1": "مراقبة المخزون في الوقت الحقيقي",
  "inv_2": "تجنب نفاد المخزون",
  "inv_3": "تحسين معدل التنفيذ",

  "guided_tours": "الجولات الإرشادية",
  "tour_1": "جولات مرئية للمبتدئين",
  "tour_2": "تسليط الضوء على الإجراءات المهمة",
  "tour_3": "مساعدة خطوة بخطوة",

  "doc_footer": "مصمم لمساعدتك على النمو بشكل أسرع والبيع بذكاء",
}